import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-beca5824")

_pushScopeId("data-v-beca5824")
const _hoisted_1 = {
  key: 0,
  class: "pin"
}
const _hoisted_2 = {
  key: 1,
  class: "pin"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "footer df-middle t-center mt-16 f-sm" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icon = _resolveComponent("Icon")
  const _component_ThePostTemplate = _resolveComponent("ThePostTemplate")
  const _component_TheImgGallery = _resolveComponent("TheImgGallery")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_component_router_link, {
    to: `/post/${_ctx.postData.postId}`,
    class: "d-b py-16"
  }, {
    default: _withId(() => [
      _createVNode(_component_ThePostTemplate, { post: _ctx.postData }, {
        default: _withId(() => [
          (_ctx.noPin && _ctx.postData.topStatus)
            ? (_openBlock(), _createBlock("div", _hoisted_1, [
                _createVNode(_component_Icon, {
                  name: "pin",
                  sm: ""
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.postData.isBoutique)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_Icon, {
                  name: "star",
                  sm: ""
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["post"]),
      (_ctx.hasImgs)
        ? (_openBlock(), _createBlock(_component_TheImgGallery, {
            key: 0,
            images: _ctx.postData.imageUrls,
            class: "mt-20"
          }, null, 8, ["images"]))
        : _createCommentVNode("", true),
      _hoisted_3
    ]),
    _: 1
  }, 8, ["to"]))
})